import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StoreRegistrationAttributeValuesCommand } from '../../../registration_attributes/commands/store_registration_attribute_values_command';
import { UpdateSelectedLinkedSectionStatusCommand } from './update_selected_linked_section_status_command';
import { SectionSelectionsQuery } from '../queries/section_selections_query';
import { RegisterSectionsQuery } from '../../../views/course_scheduler/queries/register_sections_query';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from '../../../views/course_scheduler/servants/scheduled_section_servant';
import { ISectionsDatasource } from '../../../views/sections/datasources/sections_datasource';

// TODO - Check if unselecting the toggle works
export type ProcessSelectedRegisterableSectionCommand = (
  sectionId: ISection['id'],
  isChecked: boolean
) => ng.IPromise<IQuery[]>;

/**
 * Trigger all necessary commands to select or unselect sections to register
 */
angular
  .module('capability-ng-scheduler')
  .service(
    'processSelectedRegisterableSectionCommand',
    function processSelectedRegisterableSectionCommand(
      defineCommandORM: IDefineCommand,
      $q: ng.IQService,
      ngRegisterSectionsQuery: RegisterSectionsQuery,
      ngSectionSelectionsQuery: SectionSelectionsQuery,
      storeRegistrationAttributeValuesCommand: StoreRegistrationAttributeValuesCommand,
      updateSelectedLinkedSectionStatusCommand: UpdateSelectedLinkedSectionStatusCommand,
      ngScheduledSectionServant: ScheduledSectionServant,
      ngSectionsDatasource: ISectionsDatasource
    ) {
      'use strict';

      return defineCommandORM(
        'processSelectedRegisterableSectionCommand',
        (deferred, sectionId: ISection['id'], isChecked: boolean) => {
          const section = ngSectionsDatasource.get(sectionId);
          if (!section) {
            deferred.reject('Section not found');
            return;
          }
          const canSectionBeRegistered = ngScheduledSectionServant.canBeRegistered(section);
          const canSectionBeWaitlisted = ngScheduledSectionServant.canBeWaitlisted(section);
          const isSectionWaitlisted = ScheduledSectionServant.isSectionWaitListed(section);
          if (!canSectionBeRegistered || (canSectionBeWaitlisted && !isSectionWaitlisted)) {
            deferred.resolve();
            return;
          }

          storeRegistrationAttributeValuesCommand().finally(() => {
            updateSelectedLinkedSectionStatusCommand(sectionId, isChecked)
              .then(() => {
                deferred.resolve();
              })
              .catch((error) => {
                deferred.reject(error);
              });
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/commands/process_selected_registerable_section_command.ts